// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ykYq","question":"styles_question__2PxPO","inputVisibleButton":"styles_inputVisibleButton__1TfCj","note":"styles_note__2Mt9E"};